import Games from "../components/flappyBird/Game";

const FappyBird = () => {
  return (
    <div className="game">
      <Games />
    </div>
  );
};

export default FappyBird;
